<style src="./Welcome.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="welcome">
    <transition name="show-logo">
      <img v-if="showLogo" src="static/logo/logo-397x140.png" alt="Sinkr - Logo">
    </transition>

    <transition name="show-info">
      <div v-if="showLogo" class="info">
        <h1>Bem Vindo</h1>
        <h4>Esperamos que o Sinkr possa facilitar seu trabalho hoje!</h4>
      </div>
    </transition>
  </section>
</template>

<script>

export default {
  name: 'Welcome',
  data () {
    return {
      showLogo: false
    }
  },
  mounted () {
    this.showLogo = true
  }
}
</script>



// WEBPACK FOOTER //
// src/view/welcome/Welcome.vue